import React, { useEffect } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LoaderContext } from "../context/LoaderContext";
import { UserContext } from "../context/UserContext";
import { API_URL } from "../enviormentVariables";
import { Log } from "../utils/genericUtils";

const defaultProps = {
  redirect: true,
  route: "/",
};

function TokenLogin(props = defaultProps) {
  const router = useNavigate();
  const { showloader, hideloader } = useContext(LoaderContext);
  const { user, loginUser } = useContext(UserContext);

  let _redirect = props.redirect === undefined ? true : props.redirect;

  //run once per render

  useEffect(() => {
    Log("token login props: ", props);

    let disableAutoLoginCondition = sessionStorage.getItem("disable-auto-login") === "true";
    if (user == null) {
      if ((localStorage.getItem("jwt") != null || sessionStorage.getItem("jwt") != null) && disableAutoLoginCondition === false) {
        let jwt = localStorage.getItem("jwt") ?? sessionStorage.getItem("jwt");
        JWTLogin(jwt);
      } else {
        hideloader();
        if (_redirect === true) router("/");
      }
    } else {
      Log("token login user: ", user);
    }
  }, []);

  function JWTLogin(jwt) {
    showloader();
    let request = new XMLHttpRequest();
    request.open("POST", API_URL + "/token-login");
    request.setRequestHeader("Authorization", jwt);
    request.send();
    request.onload = () => {
      let response = JSON.parse(request.response);
      if (response.success) {
        loginUser(response.user);
        setTimeout(() => {
          hideloader();
          if (_redirect === true) {
            router(props.route ? props.route : "/dashboard");
          }
        }, 100);
      } else {
        setTimeout(() => {
          hideloader();
          if (_redirect === true) router("/");
        }, 100);
        sessionStorage.removeItem("jwt");
        localStorage.removeItem("jwt");
      }
    };

    request.onerror = () => {
      sessionStorage.removeItem("jwt");
      localStorage.removeItem("jwt");
      hideloader();
    };
  }
}

export default TokenLogin;
